var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_764_4660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0133 20.2738C34.222 20.1245 34.4662 20.0326 34.7215 20.0072C34.9768 19.9818 35.2343 20.0238 35.4683 20.1291C35.7023 20.2343 35.9046 20.3991 36.055 20.607C36.2054 20.8149 36.2986 21.0586 36.3253 21.3138L36.3333 21.4658V42.2818C36.3334 42.5383 36.2662 42.7905 36.1384 43.0129C36.0105 43.2354 35.8266 43.4205 35.6049 43.5496C35.3832 43.6787 35.1314 43.7475 34.8749 43.7489C34.6183 43.7503 34.3658 43.6844 34.1427 43.5578L34.0147 43.4751L25.24 37.2071H21.6667C20.9939 37.2073 20.3459 36.9532 19.8526 36.4958C19.3593 36.0383 19.0571 35.4113 19.0067 34.7404L19 34.5404V29.2071C18.9998 28.5343 19.2539 27.8863 19.7113 27.393C20.1688 26.8997 20.7958 26.5975 21.4667 26.5471L21.6667 26.5404H25.24L34.0133 20.2738ZM42.556 24.9178C43.5346 25.7932 44.3175 26.8652 44.8535 28.0639C45.3896 29.2625 45.6666 30.5607 45.6667 31.8738C45.6666 33.1868 45.3896 34.485 44.8535 35.6837C44.3175 36.8823 43.5346 37.9543 42.556 38.8298C42.4259 38.9485 42.2735 39.0402 42.1077 39.0997C41.9419 39.1592 41.766 39.1852 41.5901 39.1763C41.4142 39.1674 41.2418 39.1237 41.0828 39.0478C40.9239 38.9719 40.7816 38.8653 40.6641 38.734C40.5466 38.6028 40.4563 38.4496 40.3983 38.2833C40.3404 38.1169 40.316 37.9408 40.3265 37.765C40.337 37.5891 40.3823 37.4171 40.4597 37.2589C40.5371 37.1007 40.645 36.9594 40.7773 36.8431C41.4766 36.2178 42.036 35.4519 42.419 34.5956C42.802 33.7393 43 32.8118 43 31.8738C43 29.9004 42.144 28.1271 40.7773 26.9044C40.645 26.7882 40.5371 26.6468 40.4597 26.4886C40.3823 26.3304 40.337 26.1584 40.3265 25.9826C40.316 25.8067 40.3404 25.6306 40.3983 25.4642C40.4563 25.2979 40.5466 25.1447 40.6641 25.0135C40.7816 24.8822 40.9239 24.7756 41.0828 24.6997C41.2418 24.6238 41.4142 24.5801 41.5901 24.5712C41.766 24.5623 41.9419 24.5884 42.1077 24.6478C42.2735 24.7073 42.4259 24.7991 42.556 24.9178ZM39.8893 27.8991C40.4483 28.3992 40.8955 29.0115 41.2018 29.6962C41.5081 30.3808 41.6665 31.1224 41.6667 31.8724C41.6668 32.6229 41.5086 33.365 41.2023 34.0501C40.8961 34.7352 40.4487 35.348 39.8893 35.8484C39.6365 36.073 39.3078 36.1931 38.9697 36.1844C38.6316 36.1757 38.3095 36.0389 38.0685 35.8016C37.8275 35.5644 37.6857 35.2444 37.6717 34.9065C37.6578 34.5686 37.7727 34.2381 37.9933 33.9818L38.1107 33.8618C38.6573 33.3711 39 32.6631 39 31.8738C39.0002 31.1912 38.7387 30.5346 38.2693 30.0391L38.1107 29.8858C37.9784 29.7695 37.8704 29.6282 37.793 29.4699C37.7156 29.3117 37.6704 29.1397 37.6598 28.9639C37.6493 28.7881 37.6737 28.6119 37.7317 28.4456C37.7896 28.2792 37.8799 28.126 37.9974 27.9948C38.1149 27.8636 38.2572 27.7569 38.4162 27.681C38.5751 27.6051 38.7475 27.5614 38.9234 27.5525C39.0993 27.5436 39.2753 27.5697 39.4411 27.6292C39.6068 27.6887 39.7592 27.7804 39.8893 27.8991Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_764_4660",
    x: 9,
    y: 10,
    width: 46.6667,
    height: 43.749,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.833333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_764_4660"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_764_4660",
    result: "effect2_dropShadow_764_4660"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_764_4660",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmuted);
export default __webpack_public_path__ + "static/media/Unmuted.4ea10c06af7037ca10d97d622890f05f.svg";
export { ForwardRef as ReactComponent };